import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class AuditLogsService {
  constructor(private http: HttpClient) {}

  public fetchAuditLogs(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/auditLog/list`
    return this.http.post(url, params)
  }

  public fetchAuditLogInfo(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/auditLog/${id}`
    return this.http.get(url, {})
  }

  public exportAuditLogs(params): Observable<any> {
    const queryString = Object.keys(params)
      .map((key) => key + '=' + params[key])
      .join('&')
    let url = `${environment.API_ENDPOINT}/admin/auditLog/export?${queryString}`

    return this.http.get(url, {
      observe: 'response',
      responseType: 'blob' as 'json',
    })
  }
}
